module.exports = __webpack_public_path__ + "img/video-production.fc320f1e.svg";